import { Dispatch, SetStateAction } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import context from "./context/shared";
import { toast } from "react-toastify";
import { centerClient } from '../../shared/clients';
import type { SetCommentModel, CommandResult } from '../../shared/generated';
import { ICommentToEdit } from "./DevicesTable";

interface IEditCommentDialogProps {
    value: ICommentToEdit | null;
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
    setValue: Dispatch<SetStateAction<ICommentToEdit>>;
}

export const EditCommentDialog = (props: IEditCommentDialogProps) => {
    const { value, setValue, show, setShow } = props;
    const { refreshTree } = context;
    const successSet = (res?: CommandResult) => {
        if (res?.Success) {
            handleClose();
            toast.success("Свойства контроллера/ов изменены!", { autoClose: 1500 });
            refreshTree();
        }
        else {
            handleClose();
            refreshTree();
            toast.error(res?.Description);
        }
    }
    const errorSet = () => {
        handleClose();
        refreshTree();
    }
    const handleChangeProperty = (comment: string | undefined) => {
        const model: SetCommentModel = {
            DeviceIds: [value?.deviceId ?? ''],
            Comment: comment
        };
        centerClient.setComment(model)
            .then((res) => successSet(res.data))
            .catch(() => errorSet());
    }
    const handleClose = () => {
        setShow(false);
    }
    const saveComment = () => {
        handleChangeProperty(value?.comment);
    }
    return (        
        value &&
        <Modal id="editCommentContainer" show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>Изменение комментария</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Label>Комментарий</Form.Label>
                <Form.Control maxLength={4096} value={value?.comment} onChange={(e) => setValue({ ...value, comment: e.target.value })} as="textarea" rows={4} />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={saveComment} variant="custom">
                    Сохранить
                </Button >
                <Button variant="custom" onClick={handleClose}>Закрыть</Button>
            </Modal.Footer>
        </Modal>    

        
        
    )
}